import { Component, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { DatePickerModule } from 'primeng/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CouponService } from '../../services/coupon.service';
import { Coupon } from '../../models/coupon';
import { CommonModule, CurrencyPipe } from '@angular/common';

import { MomentModule } from 'ngx-moment';
import moment from 'moment';

@Component({
  selector: 'app-partner-coupons',
  imports: [
    CommonModule,
    RouterModule,
    TableModule,
    DatePickerModule,
    ReactiveFormsModule,
    MomentModule,
    CurrencyPipe,
    FormsModule,
  ],
  templateUrl: './partner-coupons.component.html',
  styleUrl: './partner-coupons.component.scss',
})
export class PartnerCouponsComponent {
  title = 'Cupom-parceiro';
  coupons: Coupon[] = [];
  isLoading = false;

  since: moment.Moment;
  until: moment.Moment;

  rangeDates: (Date | null)[] = [];

  constructor(private couponService: CouponService) {
    let since = moment();
    since.subtract(1, 'year');
    this.since = since;
    this.until = moment();

    this.rangeDates = [this.since.toDate(), this.until.toDate()];

    this.fetchCoupons();
  }

  setDateRange() {
    let since = moment();
    since.subtract(1, 'year');
    let until = moment();
    this.since = moment(this.rangeDates[0]) || since;
    this.until = moment(this.rangeDates[1]) || until;

    this.fetchCoupons();
  }

  fetchCoupons() {
    this.isLoading = true;
    this.couponService
      .listPartnerCoupons(
        this.since.format('YYYY-MM-DD'),
        this.until.format('YYYY-MM-DD')
      )
      .subscribe({
        next: (response) => {
          this.isLoading = false;
          this.coupons = response;
        },
        error: (error) => {
          this.isLoading = false;
        },
      });
  }
}
